import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import search_icon from '../assets/images/search_icon.svg';
import rightarrow from '../assets/images/right.svg';
import default_header_image from '../assets/images/default_header_image.png';
import default_user from '../assets/images/default_user.webp';
import config from '../config/config';

const EditProfile = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: '', 
    profile: '',
    back_profile: '',
    user_name: '',
    display_name: '',
    bio: '',
    location: '',
    web_url: '',
  });
  const [wordCounts, setWordCounts] = useState({
    display_name: 0,
    bio: 0,
    location: 0,
    web_url: 0,
  });
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
    } else {
      axios.get(`${config.baseURL}/current-user-details`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        const { data } = response.data;
        if (data && data.user) {
          setFormData({
            profile: data.user_details.user_profile || '',
            back_profile: data.user_details.user_back_profile || '',
            user_name: data.user.user_name.replace('@', '') || '',
            display_name: data.user.name || '',
            bio: data.user_details.bio || '',            
            location: data.user_details.location || '',
            web_url: data.user_details.web_url || '',
          });
          setWordCounts({
            display_name: data.user.name.length || 0,
            bio: data.user_details.bio.length || 0,
            location: data.user_details.location.length || 0,
            web_url: data.user_details.web_url.length || 0,
          });
        }
      })
      .catch(error => {
        console.error('There was an error fetching the profile data:', error);
      });
    }
  }, [navigate]);



  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    if (name === 'profile' || name === 'back_profile') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      if (name === 'web_url') {
        if (!isValidUrl(value)) {
          setMessage({ text: 'Invalid website URL format.', type: 'error' });
        } else {
          setMessage({ text: '', type: '' });
        }
      }
      setFormData({ ...formData, [name]: value });
      setWordCounts({ ...wordCounts, [name]: value.length });
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (formData.web_url && !isValidUrl(formData.web_url)) {
      setMessage({ text: 'Invalid website URL format. Please correct it before submitting.', type: 'error' });
      return;
    }
  
    const form = new FormData();
  
    // Append all fields from formData to form
    Object.keys(formData).forEach((key) => {
      form.append(key, formData[key]);
    });
  
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No token found');
      }
  
      // Make POST request with form data
      const response = await axios.post(`${config.baseURL}/edit-profile`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.data.success) {
        setMessageWithTimeout('Profile updated successfully!', 'success');
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'There was an error updating the profile.';
      setMessage({ text: errorMessage, type: 'error' });
      console.error('There was an error updating the profile:', error);
    }
  };
  

  useEffect(() => {
    document.title = "Edit Profile - PatreonPass";
  }, []);

const handleRemoveProfile = async () => {
  try {
    const token = localStorage.getItem('token'); // Get the token from local storage
    if (!token) {
      throw new Error('No token found'); // If no token, throw an error
    }

    // Make POST request to remove profile
    const response = await axios.post(
      `${config.baseURL}/remove-profile`, 
      {
        user_id: formData.id,  // Pass formData.id from state
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,  // Add token to Authorization header
          'Content-Type': 'application/json', // Set content type to JSON
        },
      }
    );

    // If the API call is successful
    if (response.data.success) {
      setFormData(prevState => ({
        ...prevState,
        profile: null,  // Set profile image to null or default image
      }));

      // Display success message using setMessage
      setMessageWithTimeout('Profile image removed successfully!', 'success');

    } else {
      throw new Error(response.data.message || 'Failed to remove profile image.');
    }
  } catch (error) {
    // Handle error and display error message
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while removing the profile image.';
    setMessageWithTimeout(errorMessage, 'error');

    console.error('Error removing profile image:', error);
  }
};
const setMessageWithTimeout = (messageText, messageType) => {
  setMessage({ text: messageText, type: messageType });

  // Hide the message after 3 seconds
  setTimeout(() => {
    setMessage({ text: '', type: '' });
  }, 50000); // 3000 milliseconds = 3 seconds
};


const isValidUrl = (url) => {
  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9_-]+)\.([a-zA-Z]{2,})([\/a-zA-Z0-9#?&=_-]*)?$/;
  return urlRegex.test(url);
};


  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${formData.user_name}`}>@{formData.user_name}</a></h3>
                    <ul>
                      <li><Link className="active_profile_menu" to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSubmit}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>EDIT PROFILE</h1>
                  </div>
                  <div className="head_dropdown">
                    <button type="submit" className="create_post_btn_area post_btn">Save</button>
                  </div>
                </div>
                <div className="edit_profile_fields">
                    <div className="b_profile_header">
                      <div className="img_wrap">
                        <img src={formData.back_profile instanceof File ? URL.createObjectURL(formData.back_profile) : formData.back_profile || default_header_image} alt="" />  
                        <input type="file" id="back_profile" name="back_profile" className="inputfile" onChange={handleChange} />
                        <label htmlFor="back_profile">
                          <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.0004 37.9999C32.4006 37.9999 36.7782 33.6222 36.7782 28.2221C36.7782 22.822 32.4006 18.4443 27.0004 18.4443C21.6003 18.4443 17.2227 22.822 17.2227 28.2221C17.2227 33.6222 21.6003 37.9999 27.0004 37.9999Z" stroke="#00AFF0" strokeWidth="4.88889" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5 42.8888V12.3333C5 11.6583 5.54721 11.1111 6.22222 11.1111H15.7115C17.3864 11.1111 18.9176 10.1647 19.6667 8.66661C20.4157 7.1685 21.9469 6.22217 23.6219 6.22217H30.3781C32.0531 6.22217 33.5843 7.1685 34.3333 8.66661C35.0824 10.1647 36.6136 11.1111 38.2885 11.1111H47.7778C48.4528 11.1111 49 11.6583 49 12.3333V42.8888C49 45.5889 46.8112 47.7777 44.1111 47.7777H9.88889C7.18883 47.7777 5 45.5889 5 42.8888Z" stroke="#00AFF0" strokeWidth="4.88889" />
                          </svg>
                        </label>
                      </div>
                    </div>

                  <div className="b_profile_user_details">
                    <div className="b_profile_user_details_wrap">  
                      <div className="profile_avatar">
                        <div className="user_name_profile">
                          
                          {formData.profile ? (
                            // Display the profile image if it exists
                            <img
                              src={
                                formData.profile instanceof File
                                  ? URL.createObjectURL(formData.profile) // Create object URL if it's a File
                                  : formData.profile // Otherwise, use the profile URL
                              }
                              alt="User Profile"
                            />
                          ) : (
                            // Display the user's name or initials if no profile image is available
                            <span className="edit-profile-name">
  {formData.display_name
    ? formData.display_name
        .split(' ') // Split the display name into words
        .map(word => word[0]) // Get the first letter of each word
        .join('') // Join them to create initials
        .slice(0, 2) // Ensure only the first 3 characters are shown
        .toUpperCase() // Convert to uppercase
    : '' }
</span>

                          )}
                          <div className="upload_photo">
                          <input type="file" id="profile" name="profile" className="inputfile" onChange={handleChange} />
                          <label htmlFor="profile">
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M27.0004 37.9999C32.4006 37.9999 36.7782 33.6222 36.7782 28.2221C36.7782 22.822 32.4006 18.4443 27.0004 18.4443C21.6003 18.4443 17.2227 22.822 17.2227 28.2221C17.2227 33.6222 21.6003 37.9999 27.0004 37.9999Z" stroke="white" strokeWidth="4.88889" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M5 42.8888V12.3333C5 11.6583 5.54721 11.1111 6.22222 11.1111H15.7115C17.3864 11.1111 18.9176 10.1647 19.6667 8.66661C20.4157 7.1685 21.9469 6.22217 23.6219 6.22217H30.3781C32.0531 6.22217 33.5843 7.1685 34.3333 8.66661C35.0824 10.1647 36.6136 11.1111 38.2885 11.1111H47.7778C48.4528 11.1111 49 11.6583 49 12.3333V42.8888C49 45.5889 46.8112 47.7777 44.1111 47.7777H9.88889C7.18883 47.7777 5 45.5889 5 42.8888Z" stroke="white" strokeWidth="4.88889"></path>
                            </svg>

                          </label>
                          </div>
                         {formData.profile && (
                          <div className="remove_photo">
                            <button
                              className="remove_media_photo"
                              onClick={handleRemoveProfile}
                              type="button"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M18 6L6 18"
                                  stroke="#fff"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M6 6L18 18"
                                  stroke="#fff"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        )}

                        </div>
                      </div>
                    </div>
                  </div>
                 
                  <div className="editable_fields_user">
                    <div className="row">
                      <div className="col-md-12">
                        {message.text && (
                          <div className={`alert toast_alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
                            {message.text}
                          </div>
                        )}
                        <div className="mb-4 position_relative at_sign">
                          <span className="text_at_sign">@</span>
                          <input type="text" name="user_name" value={formData.user_name} onChange={handleChange} className="form-control" id="user_name" required placeholder="" maxLength={40} />
                          <label htmlFor="user_name" className="placeholder-label active_label">Username</label>
                          <div className="word_count patreo_username">https://patreonpass.com/{formData.user_name}</div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input type="text" name="display_name" value={formData.display_name} onChange={handleChange} className="form-control" id="display_name" required placeholder="" maxLength={40} />
                          <label htmlFor="display_name" className="placeholder-label active_label">Display name</label>
                          <div className="word_count">{wordCounts.display_name} / 40</div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative text_area_bio">
                          <textarea rows={3} name="bio" value={formData.bio} onChange={handleChange} className="form-control" placeholder=""  maxLength={1000}/>
                          <label htmlFor="bio" className="placeholder-label">Bio</label>
                          <div className="word_count">{wordCounts.bio} / 1000</div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input type="text" name="location" value={formData.location} onChange={handleChange} className="form-control" id="location" placeholder="" maxLength={64}/>
                          <label htmlFor="location" className="placeholder-label">Location</label>
                          <div className="word_count">{wordCounts.location} / 64</div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input type="text" name="web_url" value={formData.web_url} onChange={handleChange} className="form-control" id="web_url" placeholder="" maxLength={100}/>
                          <label htmlFor="web_url" className="placeholder-label">Website Url</label>
                          <div className="word_count">{wordCounts.web_url} / 100</div>
                        </div>


                      </div>
                    </div>
                  </div>
                  <div className="fields_menu_bottom_box">
                    <div className="edit_settings_menu_list">
                      <h3>Subscription</h3>
                      <ul>
                        <li><Link to="/subscription-settings">Subscription price and bundles <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      </ul>
                    </div>
                    <div className="edit_settings_menu_list">
                      <h3>Additional info</h3>
                      <ul>
                        <li><Link to="/SocialAccountSettings">Social Accounts <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      </ul>
                    </div>
                    <div className="edit_settings_menu_list">
                      <h3>Related settings</h3>
                      <ul>
                        <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
